module.exports = __webpack_public_path__ + "img/hs_1.e497c9d9.jpg";